import { render } from "./LegalDisclaimer.vue?vue&type=template&id=55ff9520"
import script from "./LegalDisclaimer.vue?vue&type=script&lang=js"
export * from "./LegalDisclaimer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__